// src/analytics.js
export function trackEvent(eventName, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  } else {
    // Optional: log in dev so you know if GA isn't ready
    if (process.env.NODE_ENV === "development") {
      console.log("[GA debug] Event:", eventName, params);
    }
  }
}
